module.exports.buildTranslationsObject = function buildTranslationsObject(page, isSupplier = false, homePageId) {
  if (isSupplier) {
    return page.translations.map(translation => {
      return {
        language: translation.language.code,
        slug: module.exports.getSupplierSlug(page.destination.default_language.code, translation.language.code, page.type ? page.type : translation.slug_prefix, translation.slug),
        robots: translation.robots ? translation.robots : "index,follow"
      };
    });
  }

  const isHomePage = (homePageId !== -1 && page.id === homePageId);
  const defaultLanguage = page.destination.default_language.code;

  return page.translations.map(translation => {
    let slug = module.exports.getPageSlug(page, translation);
    if (isHomePage && translation.language.code === defaultLanguage) { slug = "/"; }
    return {
      language: translation.language.code,
      slug: slug,
      robots: translation.robots ? translation.robots : "index,follow"
      };
  });
}

module.exports.getPageSlug = function getPageTranslationSlug(page, translation) {
    const defaultLocale = page.destination.default_language.code;
    const language = translation.language.code;
    const slugCategory = translation.slug_prefix;
    let slugPath = translation.slug;

    if (slugCategory) slugPath = [slugCategory, slugPath].join("/")

    if (slugPath === null || slugPath === '') {
      slugPath = '/';
    }

    if (language !== defaultLocale) {
      if(slugPath === null || slugPath === '' || slugPath === '/') {
        slugPath = '';
      }

      slugPath = `${language}/${slugPath}`;
    }

    return slugPath;
}

module.exports.getSlug = function getSlug(language, defaultLanguage, translations) {
  const translation = translations.find(tr => tr.language.code === language);

  if (!translation) return undefined;

  const slugCategory = translation.slug_prefix;
  let slugPath = translation.slug;

  if (slugCategory) slugPath = [slugCategory, slugPath].join("/")

  if (slugPath === null || slugPath === '') {
    slugPath = '/';
  }

  if (language !== defaultLanguage) {
    if(slugPath === null || slugPath === '' || slugPath === '/') {
      slugPath = '';
    }

    slugPath = `/${language}/${slugPath}`;
  }

  if (slugPath[0] !== '/') slugPath = '/' + slugPath;

  return slugPath;
}

module.exports.buildTranslationsObjectForUnits = function buildTranslationsObjectForUnits(unit, default_language) {
  return unit.product_uuid.translations.map(translation => {
    let slug = "/";
    if(default_language !== translation.language.code) slug += `${translation.language.code}/`
    slug += `${unit.product_uuid.type}/`
    slug += translation.slug;
    return {
      language: translation.language.code,
      slug,
      robots: translation.robots ? translation.robots : "index,follow"
    }
  })
}

module.exports.getSupplierSlug = function getSupplierTranslationSlug(defaultLocale, language, type, slug, integration_uuid = false) {
  const slugCategory = type;
  let slugPath = slug;

  if (slugCategory) slugPath = [slugCategory, slugPath].join("/")

  if (slugPath === null || slugPath === '') {
    slugPath = '/';
  }

  if (language !== defaultLocale) {
    if(slugPath === null || slugPath === '' || slugPath === '/') {
      slugPath = '';
    }

    slugPath = `${language}/${slugPath}`;
  }

  if (integration_uuid) { 
    slugPath = `${slugPath}/${integration_uuid}`;
  }

  return slugPath;
}

module.exports.getSuppliersTranslations = function getSuppliersTranslations(supplier) {
  const languages = supplier.destination.languages
  const defaultLanguage = supplier.destination.default_language.code
  return languages.map(language => {
    let slug = '/';
    if(language.language.code !== defaultLanguage){
      slug += `${language.language.code}/`;
    }
    slug += `${supplier.type}/${supplier.id}`

    return {
      slug: slug,
      language: language.language.code,
    }
  })
}

function addSlashAtBeggining(slug) {
  if (slug.indexOf("http") === 0) return slug;
  if (slug[0] !== "/") return "/" + slug;
  return slug;
}

module.exports.buildPageTranslationsObject = function buildTranslationsObject(page, languages, defaultLanguage, homePageId) {
  const isHomePage = (homePageId && homePageId !== -1 && page.id === homePageId);
  const defaultTranslation = page.translations.find(tr => tr.languages_code === defaultLanguage || tr.language?.code === defaultLanguage);
  const defaultPath = defaultTranslation && defaultTranslation.title ? module.exports.slugify(defaultTranslation.title) : "page-" + page.id;
  const defaultRobots = defaultTranslation && defaultTranslation.robots ? defaultTranslation.robots : "index,follow";
  const defaultSlug = isHomePage ? "/" : (defaultTranslation && defaultTranslation.slug ? defaultTranslation.slug : defaultPath);

  const output = [{ language: defaultLanguage, slug: addSlashAtBeggining(defaultSlug), robots: defaultRobots }];
  for (const language of languages) {
    if (language.code === defaultLanguage) continue;

    const translation = page.translations.find(tr => tr.languages_code === language.code || tr.language?.code === language.code);

    if (!translation) continue;
    const translatedPath = translation && translation.slug ? translation.slug : defaultSlug;
    const translatedRobots = translation && translation.robots ? translation.robots : defaultTranslation.robots;
    output.push({ language: language.code, slug: ("/" + language.code + "/" + translatedPath).replace(/\/\//ig, "/"), robots: translatedRobots });
  }

  return output;
}

/**
 * Slugifies a string.
 * @param {string} str String to slugify 
 * @returns slugified string
 */
module.exports.slugify = function slugify(str) {
  return String(str)
    .normalize('NFKD') // split accented characters into their base characters and diacritical marks
    .replace(/[\u0300-\u036f]/g, '') // remove all the accents, which happen to be all in the \u03xx UNICODE block.
    .trim() // trim leading or trailing whitespace
    .toLowerCase() // convert to lowercase
    .replace(/[^a-z0-9 -]/g, '') // remove non-alphanumeric characters
    .replace(/\s+/g, '-') // replace spaces with hyphens
    .replace(/-+/g, '-'); // remove consecutive hyphens
}

/**
 * Default slug for pages:
 * @param {string} defaultLanguage 
 * @param {string} language 
 * @returns 
 */
module.exports.getDefaultSlug = function (defaultLanguage, language, slug) {
  const parts = [];
  if (defaultLanguage !== language) parts.push(language);
  parts.push(slug);
  return parts.join("/");
}